module.exports = function (lastField) {
    return {
        event: 'BWSAUregistrationAbandoned',
        eventContext: {
            registrationLastField: lastField
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/signup/atmmapper/registration-abandoned.js
 **/